import React from 'react';
import styled from 'styled-components';
import css from '@styled-system/css';
import { FiChevronRight } from 'react-icons/fi';
import { useSelector } from 'react-redux';

export const CustomRightArrowNew = ({ onClick }) => {
  const { theme } = useSelector((state) => state.theme);

  return (
    <RightArrowBox theme={theme} onClick={onClick} className="custom-right-arrow">
      <Wrapper>
        {/* <Bg theme={theme}></Bg> */}
        <FiChevronRight />
      </Wrapper>
    </RightArrowBox>
  );
};
const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  svg {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0;
  }
`;

const Bg = styled.div`
  position: absolute;
  top: 49.6%;
  z-index: -1;
  transform: translateY(-50%);
  right: 0px;
  height: 102%;
  width: 70px;
  background: ${(props) =>
    props.theme === 'dark'
      ? 'linear-gradient(to left,  var(--dark-navy-blue) 15%, rgba(0, 15, 30, 0) 100%)'
      : 'linear-gradient(to left,  #f0f0f0 15%, rgba(0, 15, 30, 0) 100%)'};
  /* filter: blur(10px); */
`;
const RightArrowBox = styled('span')((props) =>
  css({
    position: 'absolute !important',
    right: '-10px',
    top: '60%',
    transform: 'translateY(-60%)',
    // right: 0,
    // height: '100%',
    // backgroundColor: 'rgba(0,0,0,.6)',
    zIndex: 1,
    // display: 'flex',
    // color: 'var(--dark-navy-blue)',
    cursor: 'pointer',
    // opacity: 0,
    // padding: '.7rem .2rem',

    svg: {
      zIndex: 2,
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)',
      // width: '2rem',
      // height: '3rem',
      fontSize: 35,
      color: `${props.theme === 'light' ? '#222' : '#fff'}`,
      transition: '.3s',
      background: 'var(--dark-navy-blue)',
      borderRadius: '50%'
      // '&:hover': {
      //   color: `${props.theme === 'light' ? '#000F1E' : '#F0F0F0'}`
      // }
    }
  })
);
